// import * as types from '@/store/mutation-types'
export default {
    namespaced: true,

    state: {},
    actions: {
        startOrEndTransport ({ commit }, { centerId, userName, busId }) {
            return window.axios.get(`/center/${centerId}/assistant/${userName}/start`, { params: { busId } }).then(data => {
                return data
            })
        },

        studentAttend ({ commit }, { centerId, userName, accountId, status, fromSchool }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/student-attend`, {}, {
                params: {
                    accountId,
                    status,
                    fromSchool
                }
            }).then(data => {
                return data
            })
        },

        endTrip ({ commit }, { centerId, userName, accountIds }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/at-school`, accountIds).then(data => {
                return data
            })
        },

        endTripToHome ({ commit }, { centerId, userName, accountId }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/getting-home`, {}, { params: { accountId } }).then(data => {
                return data
            })
        },

        updateNearHome ({ commit }, { centerId, userName, accountId }) {
            return window.axios.post(`/center/${centerId}/assistant/${userName}/bus-near-home`, accountId, { headers: { 'Content-Type': 'application/json' } }).then((data) => {
                return data
            })
        },

        sendBusCoordinates ({ commit }, { centerId, userName, busId, lng, lat }) {
            return window.axios.post(`center/${centerId}/assistant/${userName}/bus-coordinates`, {}, { params: { busId, lng, lat } }).then(({ data }) => {
                return data
            })
        }
    },

    mutations: {},

    getters: {}
}
